import { Flex, FlexProps, Text, defineStyle } from '@chakra-ui/react';
import { TotalDailyLimitBlock } from './TotalDailyLimitBlock';
import { UserDailyLimitBlock } from './UserDailyLimitBlock';
import { useDailyUserLimit } from '../../hooks/useDailyUserLimit';
import { useTotalDailyLimit } from '../../hooks/useTotalDailyLimit';
import React from 'react';

const faucetBlocksStyle = defineStyle({
  w: { base: '100%', md: '458px' },
  minW: '250px',
  border: '1.5px solid',
  borderColor: 'borderGrey.100',
  p: '16px',
  borderRadius: '24px',
  flexDirection: 'column',
  gap: '16px',
  backgroundColor: 'bgColorA.100',
}) as FlexProps;

export const FaucetBlock = React.memo(() => {
  const userDailyLimit = useDailyUserLimit();
  const totalDailyLimit = useTotalDailyLimit();

  return (
    <Flex as="section" w={'auto'} m={'0 auto'} flexDirection={'column'} gap={'20px'} alignItems={'center'}>
      <Text as={'h3'} lineHeight={'31.2px'} fontSize={{ base: '20px', sm: '24px' }}>
        Faucet
      </Text>
      <Flex {...faucetBlocksStyle}>
        <TotalDailyLimitBlock totalDailyLimit={totalDailyLimit} />
        <UserDailyLimitBlock totalDailyLimit={totalDailyLimit} userDailyLimit={userDailyLimit} />
      </Flex>
    </Flex>
  );
});
